import * as React from 'react';

import UserSettings32 from './UserSettings32';

export const userSettings32 = () => <UserSettings32 />;

export default {
    title: 'Icon/Logo/UserSettings32',
    component: UserSettings32,
    parameters: {
        notes: "`import UserSettings32 from 'box-ui-elements/es/icon/logo/UserSettings32';`",
    },
};
